export function toggleValue<ToggleValue1, ToggleValue2>(
  value: ToggleValue1 | ToggleValue2,
  toggle1: ToggleValue1,
  toggle2: ToggleValue2
) {
  return value === toggle1 ? toggle2 : toggle1;
}
